import { createSelector } from 'reselect'

const getData = (state, data, datetime) => {
  return data
}

const getDatetime = (state, data, datetime) => {
  return datetime
}

export const makeGetDomain = () => {
  return createSelector([getData, getDatetime], (data, datetime) => {
    try {
      if (data && datetime) {
        const date = new Date(datetime)
        const filteredDates = data
          .filter(
            datum => new Date(datum.timestamp).getYear() === date.getYear()
          )
          .map(datum => datum.timestamp)
          .slice()
          .sort()
        const domain = {
          x: [
            new Date(filteredDates[0]),
            new Date(filteredDates[filteredDates.length - 1])
          ]
        }
        return domain
      } else {
        return null
      }
    } catch (error) {
      return null
    }
  })
}



// WEBPACK FOOTER //
// ./src/selectors/chartDomainSelector.js